export const state = () => ({
  kpis: {},
  dimensions: {
    addressLine1: 'N/A',
    addressLine2: 'N/A',
    phone: 'N/A',
    fax: 'N/A',
    website: '#',
    prek: 0
  },
  latlng: {},
  hypercube: {
    qInfo: { qType: 'visualization' },
    qHyperCubeDef: {}
  },

  grade: [],
  gender: [],
  race: []
})

export const mutations = {
  updateKpis(state, data) {
    state.kpis = data
  },
  updateEnrollment(state, value) {
    state.kpis = { ...state.kpis, enrollment: value }
  },
  clearDimensions(state) {
    state.dimensions = ''
  },
  updateDimensions(state, data) {
    state.dimensions = data
  },
  updateLatlng(state, data) {
    state.latlng = data
  },
  clearOverviewValues(state) {
    state.kpis = {}
    state.dimenions = {}
    state.latlng = {}
  }
}

export const getters = {
  kpis: state => {
    return state.kpis
  },
  dimensions: state => {
    return state.dimensions
  },
  latlng: state => {
    return state.latlng
  }
}
